<template>
  <div class="transport-container10">
    <app-navigation
      imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
      rootClassName="navigationroot-class-name4"
    ></app-navigation>
    <main class="transport-main">
      <div id="transport" class="transport-hero section-container">
        <div class="transport-max-width1 max-content-container">
          <div class="transport-content-container">
            <h1 class="transport-text10">
              <span>
                COMBINATUL AUTO
                <span v-html="rawaem9"></span>
              </span>
              <span class="transport-text12">nr.4</span>
              <br />
              <span class="transport-text14">s</span>
              <span class="transport-text15">
                ervicii de
                <span v-html="rawekv3"></span>
              </span>
              <br />
              <span class="transport-text17">calitate</span>
              <br />
              <span class="transport-text18">
                IN
                <span v-html="rawn3f3"></span>
              </span>
              <span class="transport-text19">Moldova</span>
            </h1>
            <span class="transport-text20">
              <span>N</span>
              <span class="transport-text22">
                oi garantam executarea rapida și la un nivel
                <span v-html="raw5rxx"></span>
              </span>
              <br />
              <span class="transport-text24">
                inalt a comenzilor Dvs.
                <span v-html="rawfoq5"></span>
              </span>
            </span>
            <div class="transport-btns-container">
              <a
                href="https://combinatulauto.md/#servicii"
                target="_blank"
                rel="noreferrer noopener"
                class="transport-primary button-primary button-lg button"
              >
                servicii
              </a>
              <a
                href="https://combinatulauto.md/#contacts"
                target="_blank"
                rel="noreferrer noopener"
                class="transport-secondary button button-outline button-lg-border"
              >
                adresa noastra
              </a>
            </div>
          </div>
          <div class="transport-video-container">
            <div class="transport-container11"></div>
          </div>
        </div>
        <div class="transport-blue-background"></div>
      </div>
      <div class="transport-text-content">
        <h1 class="transport-text25">TRANSPORT MARFURI</h1>
        <span class="transport-text26">livrare in toata republica moldova</span>
        <span class="transport-text27">
          <span>SA „Combinatul Auto Nr.4 din Chișinău” d</span>
          <span class="transport-text29">
            ispune de mai multe camioane pentru transportarea marfurilor atit pe
            teritoriul Mun.
            <span v-html="rawe1jq"></span>
          </span>
          <span class="transport-text30">C</span>
          <span class="transport-text31">
            hisinau cit si prin
            <span v-html="rawjxov"></span>
          </span>
          <span class="transport-text32">republica</span>
          <span class="transport-text33">.</span>
          <br />
          <span class="transport-text35">
            Suntem disponibili pentru incheierea contractelor de colaborare de
            lunga durata.
            <span v-html="rawjujy"></span>
          </span>
          <span class="transport-text36">
            In
            <span v-html="rawbdiu"></span>
          </span>
          <span class="transport-text37">
            acest mod producatorii si distribuitorii vor economisi mult timp si
            bani si nu vor fi nevoiti sa intretina propria flota de camioane si
            soferi.
          </span>
          <br />
          <span></span>
        </span>
      </div>
      <div class="transport-gallery">
        <div class="transport-container12">
          <div class="transport-container13"></div>
        </div>
        <div class="transport-container14">
          <div class="transport-container15"></div>
        </div>
        <div class="transport-container16">
          <div class="transport-container17"></div>
        </div>
        <div class="transport-container18">
          <div class="transport-container19"></div>
        </div>
        <div class="transport-container20">
          <div class="transport-container21"></div>
        </div>
        <div class="transport-container22">
          <div class="transport-container23"></div>
        </div>
      </div>
      <div class="transport-numbers-banner section-container">
        <div class="transport-container24 max-content-container">
          <div class="transport-heading-container1">
            <span class="transport-text39">
              Personalul intreprinderii reprezinta o echipa profesionista, cu
              experienta vasta in domeniu.
              <span v-html="raw6h2v"></span>
            </span>
            <h1 class="transport-text40 Heading2">
              <span>
                servicii la preturi accesibile
                <span v-html="rawtybe"></span>
              </span>
            </h1>
          </div>
          <div class="transport-numbers-container">
            <numbers-card text="expeditiii"></numbers-card>
            <numbers-card
              text="ani"
              number="12"
              imageSrc="/interface%20time%20reset-200h.webp"
            ></numbers-card>
            <numbers-card
              text="evenimente"
              number="64"
              imageSrc="/interface%20calendar%20favorite-200h.webp"
            ></numbers-card>
            <numbers-card
              text="companii"
              number="234"
              imageSrc="/shopping%20bag%20suit%20case-200h.webp"
            ></numbers-card>
            <numbers-card
              text="orase"
              number="14"
              imageSrc="/travel%20map%20location%20pin-200h.webp"
            ></numbers-card>
            <numbers-card
              text="diagnosticari"
              number="1,071"
              imageSrc="/interface%20time%20reset-200h.webp"
            ></numbers-card>
          </div>
        </div>
      </div>
      <div class="transport-previous-events section-container">
        <div class="transport-max-width2 max-content-container">
          <div class="transport-heading-container2">
            <h1 class="transport-text42 Heading2">
              <span>PARTENERUL TAU DE INCREDERE</span>
            </h1>
            <span class="transport-text44">
              garantam executarea rapida si calitativa a comenzilor Dumneavoastra
            </span>
          </div>
        </div>
      </div>
    </main>
    <app-footer rootClassName="footerroot-class-name4"></app-footer>
  </div>
</template>

<script>
import AppNavigation from '../components/navigation'
import NumbersCard from '../components/numbers-card'
import AppFooter from '../components/footer'

export default {
  name: 'Transport',
  props: {},
  components: {
    AppNavigation,
    NumbersCard,
    AppFooter,
  },
  data() {
    return {
      rawaem9: ' ',
      rawekv3: ' ',
      rawn3f3: ' ',
      raw5rxx: ' ',
      rawfoq5: ' ',
      rawe1jq: ' ',
      rawjxov: ' ',
      rawjujy: ' ',
      rawbdiu: ' ',
      raw6h2v: ' ',
      rawtybe: ' ',
    }
  },
  metaInfo: {
    title: 'Transport - SA Combinatul Auto Nr.4 din Chișinău',
    meta: [
      {
        name: 'description',
        content:
          'SA Combinatul Auto Nr.4 din Chișinău, oferă o gamă largă de servicii electrice și mecanice la prețuri accesibile pentru fiecare.',
      },
      {
        property: 'og:title',
        content: 'Transport - SA Combinatul Auto Nr.4 din Chișinău',
      },
      {
        property: 'og:description',
        content:
          'SA Combinatul Auto Nr.4 din Chișinău, oferă o gamă largă de servicii electrice și mecanice la prețuri accesibile pentru fiecare.',
      },
      {
        property: 'og:image',
        content:
          'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/7df3687e-9d61-4851-bd9b-b6ae978e2570/ea494eb0-6cf8-464c-b070-cddce041bc5c?org_if_sml=1&q=80&force_format=original',
      },
    ],
  },
}
</script>

<style scoped>
.transport-container10 {
  width: 100%;
  display: flex;
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  align-items: center;
  flex-direction: column;
}
 
.transport-main {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
 
.transport-hero {
  position: relative;
  padding-top: 128px;
}
 
.transport-max-width1 {
  z-index: 1;
  align-items: stretch;
}
 
.transport-content-container {
  flex: 1;
  display: flex;
  max-width: 45%;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
 
.transport-text10 {
  font-size: 60px;
  font-style: normal;
  font-family: IBM Plex Sans Condensed;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: var(--dl-space-space-unit);
  text-transform: uppercase;
  text-decoration: none;
}
 
.transport-text12 {
  text-transform: lowercase;
}
 
.transport-text14 {
  color: var(--dl-color-scheme-pink);
}
 
.transport-text15 {
  color: var(--dl-color-scheme-pink);
  text-transform: lowercase;
}
 
.transport-text17 {
  color: var(--dl-color-scheme-pink);
  text-transform: lowercase;
}
 
.transport-text18 {
  font-style: normal;
  font-weight: 600;
  text-transform: lowercase;
}
 
.transport-text19 {
  font-style: normal;
  font-weight: 600;
  text-transform: capitalize;
}
 
.transport-text20 {
  font-style: normal;
  font-weight: 500;
  margin-bottom: 42px;
}
 
.transport-text22 {
  text-transform: lowercase;
}
 
.transport-text24 {
  text-transform: lowercase;
}
 
.transport-btns-container {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
}
 
.transport-primary {
  margin-right: var(--dl-space-space-oneandhalfunits);
  text-decoration: none;
}
 
.transport-secondary {
  text-decoration: none;
}
 
.transport-video-container {
  flex: 1;
  width: 200px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
 
.transport-container11 {
  width: 100%;
  height: 511px;
  display: flex;
  transition: 0.3s;
  background-size: cover;
  background-image: url("/home-1200h.webp");
  background-position: center;
}
 
.transport-container11:hover {
  transform: scale(1.02);
  box-shadow: 5px 5px 10px 0px rgba(111, 102, 102, 0.31);
}
 
.transport-blue-background {
  top: 0px;
  right: 0px;
  width: 47%;
  height: 100px;
  position: absolute;
  min-height: 80%;
  background-size: cover;
  background-image: url("/blue-bg-1500w.webp");
  background-repeat: no-repeat;
}
 
.transport-text-content {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-twounits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  justify-content: space-between;
}
 
.transport-text25 {
  font-size: 3rem;
  text-align: center;
}
 
.transport-text26 {
  color: var(--dl-color-scheme-darkgray);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
.transport-text27 {
  max-width: var(--dl-size-size-maxwidth);
  margin-top: var(--dl-space-space-twounits);
  text-align: center;
  margin-bottom: var(--dl-space-space-twounits);
  text-transform: uppercase;
}
 
.transport-text29 {
  text-transform: lowercase;
}
 
.transport-text30 {
  text-transform: capitalize;
}
 
.transport-text31 {
  text-transform: lowercase;
}
 
.transport-text32 {
  text-transform: capitalize;
}
 
.transport-text33 {
  text-transform: lowercase;
}
 
.transport-text35 {
  text-transform: lowercase;
}
 
.transport-text36 {
  text-transform: capitalize;
}
 
.transport-text37 {
  text-transform: lowercase;
}
 
.transport-gallery {
  width: 100%;
  height: 1200px;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  max-width: var(--dl-size-size-maxwidth);
  align-self: center;
  align-items: flex-start;
  padding-top: var(--dl-space-space-twounits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  padding-bottom: var(--dl-space-space-twounits);
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-areas: "a b b" "a b b" "a c d" "a c d"  "e e d" "e e f" "e e f";
  grid-template-columns: 1fr 1fr 1fr;
}
 
.transport-container12 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  opacity: 1;
  grid-area: a;
  transition: 0.3s;
  align-items: flex-start;
  flex-direction: column;
}
 
.transport-container12:hover {
  transform: scale(0.98);
}
 
.transport-container13 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: flex-start;
  flex-direction: column;
  background-size: cover;
  background-image: url("/home-1200h.webp");
  background-position: center;
}
 
.transport-container14 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  grid-area: b;
  transition: 0.3s;
  align-items: flex-start;
  flex-direction: column;
  background-size: cover;
  background-image: url("/22-1200h.webp");
  background-position: center;
}
 
.transport-container14:hover {
  transform: scale(0.98);
}
 
.transport-container15 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: flex-start;
  flex-direction: column;
}
 
.transport-container16 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  grid-area: c;
  transition: 0.3s;
  align-items: flex-start;
  flex-direction: column;
  background-size: cover;
  background-image: url("/15-1200h.webp");
  background-position: left;
}
 
.transport-container16:hover {
  transform: scale(0.98);
}
 
.transport-container17 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(--dl-space-space-twounits);
  align-items: flex-start;
  flex-direction: column;
}
 
.transport-container18 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  grid-area: d;
  transition: 0.3s;
  align-items: flex-start;
  flex-direction: column;
  background-size: cover;
  background-image: url("/23-1200h.webp");
  background-repeat: no-repeat;
  background-position: left;
}
 
.transport-container18:hover {
  transform: scale(0.98);
}
 
.transport-container19 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: flex-start;
  flex-direction: column;
}
 
.transport-container20 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  grid-area: e;
  transition: 0.3s;
  align-items: flex-start;
  flex-direction: column;
  background-size: cover;
  background-image: url("/20-1200h.webp");
  background-position: center;
}
 
.transport-container20:hover {
  transform: scale(0.98);
}
 
.transport-container21 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: flex-start;
  flex-direction: column;
}
 
.transport-container22 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  grid-area: f;
  transition: 0.3s;
  align-items: flex-start;
  flex-direction: column;
  background-size: cover;
  background-image: url("/24-1200h.webp");
  background-position: center;
}
 
.transport-container22:hover {
  width: 100%;
  height: 100%;
  transform: scale(0.98);
}
 
.transport-container23 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: flex-start;
  flex-direction: column;
}
 
.transport-numbers-banner {
  display: flex;
  padding-top: var(--dl-space-space-fiveunits);
  flex-direction: column;
  background-size: cover;
  background-image: url("/29bg-1500w.webp");
}
 
.transport-container24 {
  flex-direction: column;
}
 
.transport-heading-container1 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.transport-text39 {
  color: var(--dl-color-scheme-white);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
.transport-text40 {
  color: var(--dl-color-scheme-white);
  text-align: center;
}
 
.transport-numbers-container {
  width: 100%;
  display: grid;
  grid-row-gap: var(--dl-space-space-fourunits);
  grid-column-gap: 30px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}
 
.transport-previous-events {
  display: flex;
  position: relative;
  flex-direction: column;
  padding-bottom: 150px;
}
 
.transport-max-width2 {
  flex-direction: column;
}
 
.transport-heading-container2 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.transport-text42 {
  text-align: center;
}
 
.transport-text44 {
  color: var(--dl-color-scheme-darkgray);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
@media(max-width: 991px) {
  .transport-max-width1 {
    flex-direction: column;
  }
  .transport-content-container {
    max-width: 100%;
    margin-bottom: 42px;
  }
  .transport-container11 {
    width: 583px;
  }
  .transport-blue-background {
    top: auto;
    width: 100%;
    bottom: 0px;
    min-height: 40%;
  }
  .transport-text27 {
    max-width: 100%;
  }
  .transport-gallery {
    grid-gap: var(--dl-space-space-unit);
  }
  .transport-numbers-container {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
 
@media(max-width: 767px) {
  .transport-container11 {
    width: 505px;
  }
  .transport-text-content {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .transport-text27 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .transport-gallery {
    height: auto;
    display: flex;
    padding: var(--dl-space-space-twounits);
    flex-direction: column;
  }
  .transport-container13 {
    height: var(--dl-size-size-xxlarge);
  }
  .transport-container15 {
    height: var(--dl-size-size-xxlarge);
  }
  .transport-container17 {
    height: var(--dl-size-size-xxlarge);
  }
  .transport-container19 {
    height: var(--dl-size-size-xxlarge);
  }
  .transport-container21 {
    height: var(--dl-size-size-xxlarge);
  }
  .transport-container23 {
    height: var(--dl-size-size-xxlarge);
  }
  .transport-numbers-container {
    grid-template-columns: 1fr 1fr;
  }
  .transport-previous-events {
    padding-bottom: var(--dl-space-space-sixunits);
  }
}
 
@media(max-width: 479px) {
  .transport-text10 {
    font-size: 60px;
  }
  .transport-container11 {
    width: 424px;
  }
  .transport-text-content {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .transport-gallery {
    width: 100%;
    padding: var(--dl-space-space-unit);
  }
  .transport-container13 {
    width: 100%;
    height: var(--dl-size-size-xxlarge);
  }
  .transport-container15 {
    height: var(--dl-size-size-xxlarge);
  }
  .transport-container17 {
    height: var(--dl-size-size-xxlarge);
  }
  .transport-container19 {
    height: var(--dl-size-size-xxlarge);
  }
  .transport-container21 {
    height: var(--dl-size-size-xxlarge);
  }
  .transport-container23 {
    height: var(--dl-size-size-xxlarge);
  }
}
</style>
